export default "__VITE_ASSET__C4vrbG3W__"